import React, { PureComponent } from 'react';
import cn from 'classname';

import PayoutRow from './payout-row';

import includes from 'lodash/includes';

function createMainPayoutRow(payout, isOpen, onClick) {
	return (
		<PayoutRow
			className={cn({
				'divided-payout': payout.isDivided,
				'divided-payout-open': isOpen
			})}
			payout={payout}
			onClick={payout.isDivided && onClick}
			key={`main-${payout.id}`}
		/>
	);
}

function createPartPayoutRow(payout, index, children) {
	return (
		<PayoutRow
			className={cn('part-payout', {
				'part-payout-first': index === 0,
				'part-payout-last': index === children.length - 1
			})}
			payout={payout}
			key={`part-${payout.id}`}
		/>
	);
}

class PayoutBody extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			selectedPayoutIds: []
		};
	}

	select(payoutId) {
		this.setState(({ selectedPayoutIds }) => ({
			selectedPayoutIds: includes(selectedPayoutIds, payoutId)
				? selectedPayoutIds.filter((id) => id !== payoutId)
				: selectedPayoutIds.concat(payoutId)
		}));
	}

	getRows() {
		return this.props.rows.reduce((rows, { payout, children }) => {
			const isOpen = includes(this.state.selectedPayoutIds, payout.id);

			rows.push(createMainPayoutRow(payout, isOpen, () => this.select(payout.id)));

			if (isOpen) {
				rows.push(...children.map(createPartPayoutRow));
			}

			return rows;
		}, []);
	}

	render() {
		return (
			<tbody className={this.props.className}>
				{this.getRows()}
			</tbody>
		);
	}
}

export default PayoutBody;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/components/payout-table/payout-body.js